module.exports = __webpack_public_path__ + "static/media/battle.38b93615.png";